import Vue from 'vue'

// add translations directly to the application
Vue.i18n.add('en', require('./en.json'))
Vue.i18n.add('it', require('./it.json'))
// Vue.i18n.add('es', require('./es.json'))

// set the start locale to use
Vue.i18n.set('it')

// set fallback for non-translated strings
Vue.i18n.fallback('it')



// WEBPACK FOOTER //
// ./src/i18n/index.js